import type { ChangeEvent, RefObject } from 'react'
import React, { memo } from 'react'

import { InputUI } from '@fourthwall/components'

import { SEARCH_CHARS_MAX_LIMIT } from '../../../../consts'
import * as S from './styled'

type CategoryInputProps = {
  value: string
  hasLabel: boolean
  disabled: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  inputRef: RefObject<HTMLInputElement>
}

export const CategoryInput = memo(
  ({ value, hasLabel, disabled, inputRef, onChange }: CategoryInputProps) => {
    return (
      <S.Container>
        <InputUI.Input
          data-testid="Input"
          $inputSize="large"
          type="text"
          ref={inputRef}
          value={value}
          $hasLabel={hasLabel}
          disabled={disabled}
          maxLength={SEARCH_CHARS_MAX_LIMIT}
          onChange={onChange}
        />
      </S.Container>
    )
  },
)
